import React, { Component, Fragment } from "react"
import { SystemServices } from "../../services"

//components
import PageHeader from "../../components/Page/PageHeader/PageHeader"

export default class SystemSubmodulesPage extends React.Component {
  state = {
    type: "",
    systemSubModule: []
  }

  componentWillMount() {
    const { type } = this.props.location.state

    this.setState({
      type: type,
    })
    this.getParticularSubmoduleList(type)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.type !== this.state.type) {
      const { type } = nextProps.location.state
      this.setState({
        type: type,
      })
      this.getParticularSubmoduleList(type)
    }
  }

  getParticularSubmoduleList(subModule) {
    SystemServices.getSystemInfo(subModule)
      .then(response => {
        if (response.status == 200) {
          this.setState({ systemSubModule: response.text.data })
        }
        response.status === 401 && this.props.unauthorisedFunc()
      })
      .catch(error => {
        this.props.getalertMessage("error", error)
      })
  }

  pageNavigate(moduleName, categoryName) {
    if (
      moduleName !== "EMBROIDERY / EMBELISHMENT" &&
      moduleName !== "GREIGE / DENIM" &&
      categoryName !== "FINISH(FEEL)"
    ) {
      // this.props.history.push(
      //   `/${this.state.type}?${moduleName.replace(
      //     /\s/g,
      //     ""
      //   )}?${categoryName.replace(/\s/g, "_")}`
      // );
      this.props.history.push({
        pathname: `/${this.state.type}`,
        search: `?${moduleName.replace(/\s/g, "")}?${categoryName.replace(
          /\s/g,
          "_"
        )}`
      })
    } else if (categoryName === "FINISH(FEEL)") {
      this.props.history.push({
        pathname: `/${this.state.type}`,
        search: `?${moduleName.replace(/\s/g, "")}?FINISH(FEEL)`
      })
    } else if (moduleName === "GREIGE / DENIM") {
      this.props.history.push({
        pathname: `/${this.state.type}`,
        search: `?GREIGE&DENIM?${categoryName.replace(/\s/g, "_")}`
      })
    } else if (moduleName === " ") {
      this.props.history.push({
        pathname: `/${this.state.type}`,
        search: `?GREIGE&DENIM?${categoryName.replace(/\s/g, "_")}`
      })
    } else if (moduleName === "GREIGE / DENIM") {
      this.props.history.push({
        pathname: `/${this.state.type}`,
        search: `?GREIGE&DENIM?${categoryName.replace(/\s/g, "_")}`
      })
    } else {
      this.props.history.push(
        `/${this.state.type}?EMBROIDERY&EMBELISHMENT?${categoryName.replace(
          /\s/g,
          "_"
        )}`
      )
      this.props.history.push({
        pathname: `/${this.state.type}`,
        search: `?EMBROIDERY&EMBELISHMENT?${categoryName.replace(/\s/g, "_")}`
      })
    }
  }

  render() {
    return (
      <Fragment>
        <div class="right-section">
          <div class="row nopadding">
            <div class="col-md-12 nopadding">
              <div
                class="card-filter meeting-min-con"
                style={{ marginBottom: "0.5%" }}
              >
                <div class="row fabric-list-con">
                  <PageHeader
                    header={this.state.type}
                    history={this.props.history}
                  />
                </div>
              </div>
              {this.state.systemSubModule ? (
                this.state.systemSubModule.map((moduleValue, index) => (
                  <div
                    class="card-filter meeting-min-con"
                    key={moduleValue._id}
                    style={{ marginBottom: "0.5%" }}
                  >
                    <div class="row fabric-list-con">
                      <div
                        class="col-md-12 product-form"
                        style={{ paddingBottom: "1%" }}
                      >
                        <h6 class="dev-title" style={{ paddingBottom: "10px" }}>
                          <b>{moduleValue.module}</b>
                        </h6>
                        {moduleValue.categories.map((category, key) => (
                          <div
                            key={key}
                            class="col-md-3"
                            onClick={() =>
                              this.pageNavigate(
                                moduleValue.module,
                                category.name
                              )
                            }
                          >
                            <div class="box-con">
                              <div class="cart-list">
                                <a
                                  onClick={() =>
                                    this.pageNavigate(
                                      moduleValue.module,
                                      category.name
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <span class="text-center">
                                    <h6 class="line">{category.name}</h6>
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p> Loading </p>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/systemSubModules/page.js